export default __webpack_public_path__ + "static/media/icon_home.c8ef6882.svg";